if (window.matchMedia("(max-width: 768px)").matches) {
  /* the viewport is less than 768 pixels wide */
}

var j$ = jQuery,
  $nav = j$(".list-menu"),
  $slideLine = j$("#slide-line"),
  $currentItem = j$(".active_head");
j$(function () {
  $currentItem[0] &&
    $slideLine.css({
      width: $currentItem.width(),
      left: $currentItem.position().left,
    }),
    j$($nav)
      .find(".menu-top-level")
      .hover(
        function () {
          $slideLine.css({
            width: j$(this).width(),
            left: j$(this).position().left,
          });
        },
        function () {
          $currentItem[0]
            ? $slideLine.css({
                width: $currentItem.width(),
                left: $currentItem.position().left,
              })
            : $slideLine.width(0);
        }
      );
}),
  $(document).ready(function () {
    $(window).on("load", function () {
      $(".loader").removeClass("loader_active");
    });
    $(function () {
      if (
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1
      ) {
        $("body").addClass("safari-mac");
      }
    });
    //   featured-logo slider code start
    $(".featured--logo-wrap").slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1000,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    //   featured-logo slider code end
    $(".image-with-links--wrapper .image-with-links--content").on(
      "init",
      function (event, slick) {
        $(".image-with-links--wrapper .image-with-links--content").attr(
          "style",
          ""
        );
      }
    );

    $(".image-with-links--wrapper .image-with-links--content").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick",
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
      ],
    });
    
    document
      .querySelectorAll(`.collageTemplate--headings`)
      .forEach((item22, index) => {
        if (index == 0) {
          item22.setAttribute("data-default", "true");
        }
      });

    document.querySelectorAll(".collageTemplate--headings").forEach((item) => {
      item.onclick = (e) => {
        document
          .querySelectorAll(`.collageTemplate--headings`)
          .forEach((item22) => {
            item22.className = "collageTemplate--headings";
          });
        e.target.className = "collageTemplate--headings active";
        document.querySelectorAll(`.contents__wrap`).forEach((item2) => {
          item2.style.display = "none";
        });
        var x =
          document.querySelector(`.collageTemplate--headings.active`)
            .offsetLeft +
          20 -
          window.innerWidth / 2;
        // console.log(x,window.innerWidth);
        document.querySelector(`.collage--contents-title-wrap`).scrollLeft = x;
        document.querySelector(`.contents__wrap.${e.target.id}`).style.display =
          "block";
      };
    });

    if (document.querySelector(`[data-default="true"]`) != undefined) {
      document.querySelector(`[data-default="true"]`).click();
    }

    // mega-menu view-more button start
    $(".grandchild_link__wrapper ul li:nth-last-child(7)").addClass(
      "viewbutton_devicess"
    );

    $("li.viewbutton_device").nextAll("li").hide();
    $(".device_view_more").on("click", function () {
      $(this).hide();
      $("li.viewbutton_device").nextAll("li").show();
    });

    $("li.viewbutton_category").nextAll("li").hide();
    $(".cat_view_more").on("click", function () {
      $(this).hide();
      $("li.viewbutton_category").nextAll("li").show();
    });

    //   PRODUCT PAGE'S DESCRIPTION JS start

    $(".featu-learn-more").on("click", function () {
      $("html, body").animate(
        {
          scrollTop: $(".premium--feature-wrap #home--IWT").offset().top - 10,
        },
        1000
      );
    });

    //   mobile menu js start
    $(document).on(
      "click",
      ".has-childmenu--js .Mmenu-link--heding",
      function () {
        var $el_this = $(this),
          $el_wrap_li = $el_this.closest("li"),
          $el_next_div = $el_this.next();

        $el_this.toggleClass("active__mainmenu");
        $el_wrap_li.toggleClass("active__MainMenu-li");
        $el_next_div.slideToggle();
      }
    );

    $(document).on("click", ".image__link", function () {
      setTimeout(function () {
        var highestBox = 0;
        $(".iwl--wrap").each(function () {
          console.log($(this).height());
          if ($(this).height() > highestBox) {
            highestBox = $(this).height();
          }
        });
        $(".iwl--wrap").height(highestBox);
      }, 100);
    });

    $(document).on("click", ".mega__menu_li", function () {
      $(this).next().slideToggle();
    });

    // custom sticky add to cart
    $(document).on("click", ".customatc--button", function () {
      $(".product-form__submit").click();
    });

    const $stickyatc = $("#stickyatc");

    const togglestickyatc = () => {
      $stickyatc.toggleClass("is-active", $(window).scrollTop() > 1100);
    };

    $stickyatc.on("click", function () {
      $("html, body").animate({ scrollTop: $(document).height() }, "fast");
    });

    $(window).on("scroll", togglestickyatc);


     const $stickyatcs = $("#hs-stickyatc");

    const togglestickyatcs = () => {
      $stickyatcs.toggleClass("is-active", $(window).scrollTop() > 800);
    };

    $stickyatcs.on("click", function () {
      $("html, body").animate({ scrollTop: $(document).height() }, "fast");
    });

    $(window).on("scroll", togglestickyatcs);
    

    const accordionBtns = document.querySelectorAll(".footer-block__heading");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("active");

        let content = this.nextElementSibling;
        console.log(content);

        if (content.style.maxHeight) {
          //this is if the accordion is open
          content.style.maxHeight = null;
        } else {
          //if the accordion is currently closed
          content.style.maxHeight = content.scrollHeight + "px";
          console.log(content.style.maxHeight);
        }
      };
    });

    document.querySelectorAll(".first-level-link").forEach((item) => {
      item.onclick = (e) => {
        if (
          e.currentTarget.children[1].children[0].children[0].children[0].classList.contains(
            "active__menu"
          )
        ) {
          e.currentTarget.children[1].children[0].children[0].children[0].classList.remove(
            "active__menu"
          );
        } else {
          e.currentTarget.children[1].children[0].children[0].children[0].classList.add(
            "active__menu"
          );
        }
      };
    });

    $(document).on(
      "click",
      ".secondlevel-menu--js,.thirdlevel-menu--js",
      function (e) {
        e.preventDefault();
        var $el = $(this),
          $el_wrap = $el.closest("li"),
          $el_next = $el.next();
        $el.toggleClass("active");
        $el_wrap.toggleClass("active__menu-li");
        $el_next.slideToggle();
      }
    );
    $(".slider-mobile-gutter ul li:last-child").addClass("li_last_image");
    $(".slider-mobile-gutter ul li:nth-last-child(2)").addClass(
      "li_last_image"
    );

    $(".moreless-button").click(function (e) {
      e.preventDefault();
      $(".product_moretext").slideToggle();
      if ($(".moreless-button").text() == "Read More") {
        $(this).text("Read Less");
      } else {
        $(this).text("Read More");
      }
    });
    //     cart page share button code start here
    $(document).ready(function () {
      $(".fancybox_share").click(function () {
        $("#share_fancy_box").show();
        $("body").addClass("share-fancy-overlay");
      });
      $(".fancybox-share-close").click(function () {
        $("#share_fancy_box").hide();
        $("body").removeClass("share-fancy-overlay");
      });
    });

    //desktop menu active class
    $(".menu-top-level").hover(
      function () {
        $(this).addClass("current_menu_active");
      },
      function () {
        $(this).removeClass("current_menu_active");
      }
    );

    var url = window.location.pathname,
      fullurl = window.location.href,
      urlRegExp = new RegExp(url.replace(/\/$/, "") + "$");
    $(".grandchild_link__wrapper ul li a").each(function () {
      // and test its normalized href against the url pathname regexp
      if (fullurl == this.href.replace(/\/$/, "")) {
        $(".has-mega--menu").removeClass("active_head");
        $(this).closest(".has-mega--menu").addClass("active_head");
        return false;
      }
    });
    $(".mega-menu--wrapper a").each(function () {
      // and test its normalized href against the url pathname regexp
      if (fullurl == this.href.replace(/\/$/, "")) {
        $(".has-mega--menu").removeClass("active_head");
        $(this).closest(".has-mega--menu").addClass("active_head");
        return false;
      }
    });
    $(".header__submenu li a").each(function () {
      // and test its normalized href against the url pathname regexp
      if (fullurl == this.href.replace(/\/$/, "")) {
        $(".has-mega--menu").removeClass("active_head");
        $(this).closest(".has-mega--menu").addClass("active_head");
        return false;
      }
    });
    $(".login_button").prop("disabled", true);
    $("#login_condition").change(function () {
      if ($(this).prop("checked")) {
        $(".login_button").prop("disabled", false);
      } else {
        $(".login_button").prop("disabled", true);
      }
    });
  });

// console.log(max_height);
// setTimeout(function(myRadio) {
//   if (!checkVariantExist(window.location.search, 'variant')) {
//     window.history.replaceState({path: window.location.href + '?variant='+shopifyVariantSelected}, '', window.location.href + '?variant='+shopifyVariantSelected);
//   }
// },10);

// function checkVariantExist(url, field) {
//     if(url.indexOf('?' + field + '=') != -1)
//       return true;
//     else if(url.indexOf('&' + field + '=') != -1)
//       return true;
//   return false
// }

// $("#matchOptions .soldout").remove();

$(document).on("click",".product-form__submit",function(e) {
  // If product contains no variant
  if ($(this).hasClass("default-variant")) {
    return true;
  }
  // var th = $(this);
  $(".customRadio li input").each(function () {
    if ($(".customRadio li input").is(":checked")) {
      $(this).parents(".custom-color-swatch").addClass("no-error");
      $(this).parents(".custom-color-swatch").removeClass("show-error");
    } else {
      $(this).parents(".custom-color-swatch").addClass("show-error");
    }
  });

  // for radios
  // var radio_val = false
  $('fieldset.product-form__input input[name="Size"]').each(function () {
    // radio_val = $(this).find('input').is(':checked') ? $(this).parents('.product-form__input').removeClass('no-error') : false;
    // console.log('radio_val each=',radio_val)
    // if(radio_val == true){
    //   console.log('true')
    //   $(this).parents('.product-form__input').find('error').hide();
    // }
    if ($('fieldset.product-form__input input[name="Size"]').is(":checked")) {
      console.log("size checked");
      $(this).parents(".product-form__input").addClass("no-error");
      $(this).parents(".product-form__input").removeClass("show-error");
    } else {
      console.log("size unchecked");
      $(this).parents(".product-form__input").addClass("show-error");
    }
  });
  $('fieldset.product-form__input input[name="Color"]').each(function () {
    if ($('fieldset.product-form__input input[name="Color"]').is(":checked")) {
      console.log("color checked");
      $(this).parents(".product-form__input").addClass("no-error");
      $(this).parents(".product-form__input").removeClass("show-error");
    } else {
      console.log("color unchecked");
      $(this).parents(".product-form__input").addClass("show-error");
    }
  });
  if (
    $('fieldset.product-form__input input[name="Size"]').is(":checked") &&
    $('fieldset.product-form__input input[name="Color"]').is(":checked")
  ) {
    return true;
  }

  var combinations = [];
  $("variant-selects select").each(function () {
    $("#" + $(this).attr("id")).change();
    var selectedOption = $("#" + $(this).attr("id") + " option:selected").val();
    combinations.push(selectedOption);
  });
  let isFound = false;
  let comma_seprated = combinations.join(" / ");

  $("#matchOptions > option").each(function () {
    if ($(this).text() == comma_seprated) {
      console.log($(this).text(), " ", comma_seprated);
      isFound = true;
      //th.parents('.product-form form').submit();
    }
  });

  if (isFound) {
    return true;
  }

  return false;
});

$(document).on("change",".product-form__input--dropdown .change-option",function() {
  setTimeout(function () {
    $(".pro-price-box").removeClass("visibility-hidden");
    $(".product-form__buttons button").prop("disabled", false);
    $("button.product-form__submit span").text("Add to cart");
  }, 500);
});

var currentValue = "";
function handleClick(myRadio) {
  
  $('.hs-developer-csm .thumbnail-list li').hide();
  const $select = document.querySelector("select.option-Color");
  $select.value = myRadio.getAttribute("label");
  $select.img = myRadio.getAttribute("data-img");
  $('.product__media-list li:first-child img').attr('srcset',$select.img);
  $('.product__media-list li:first-child img').attr('src',$select.img);
  
  $('.hs-developer-csm .thumbnail-list').find('li[data-alt="'+$select.value+'"]').show();
 
  if($('.hs-developer-csm .thumbnail-list').find('li[data-alt="'+$select.value+'"]').length == 0){
     $('.hs-developer-csm .thumbnail-list').find('li').show();
  }

  if ($(window).width() < 767) {
    $('ul.product__media-list li').hide();
    $('ul.product__media-list li:first-child').hide();
    $('ul.product__media-list').find('li[data-alt="'+$select.value+'"]').show();
    if($('ul.product__media-list').find('li[data-alt="'+$select.value+'"]').length == 0){
         $('ul.product__media-list').find('li').show();
    }
  }

   let element = document.querySelector("select.option-Color");
    element.value = myRadio.getAttribute("label");
    var u = document.createEvent("Events"); 
    u.initEvent("change", !0, !1);
    jQuery(element)[0].dispatchEvent(u);
   // $('.product--stacked .product__media-list .product__media-item').removeClass('full-image');
   // setTimeout(function(){ $('.product--stacked .product__media-list .product__media-item:visible:first').addClass('full-image'); }, 500);
  
  colorSwatches();
}

function colorSwatches() {
  var combinations = [];
  $("variant-selects select").each(function () {
    $("#" + $(this).attr("id")).change();
    var selectedOption = $("#" + $(this).attr("id") + " option:selected").val();
    combinations.push(selectedOption);
  });

  let comma_seprated = combinations.join(" / ");
  let isFound = false;
  let aviable = true;
  $("#matchOptions > option").each(function () {
    if ($(this).text() == comma_seprated) {
      isFound = true;
      $(".product-form__buttons button").prop("disabled", true);
      $(".firstLi:first img").attr({
        srcset: $(this).attr("data-img"),
        src: $(this).attr("data-img"),
      });
      var queryParams = new URLSearchParams(window.location.search);
     
      queryParams.set("variant", $(this).val());
      $(".pro-form-hidden-field").val($(this).val());
     
      history.replaceState(null, null, "?" + queryParams.toString());

      var var_price = $(this).attr('data-var-price');
      var var_cprice = $(this).attr('data-cvar-price');
      var data_discount = $(this).attr('data-discount');
      if(var_cprice){
           $('.pro-price-box .price').addClass('price--on-sale')
           $('.price--on-sale .price__sale .price-item.price-item--sale').text(var_price)
           $('.price--on-sale .price__sale .price-item.price-item--regular').text(var_cprice)
           $('.discount-off').text(data_discount)
       }else{
         $('.pro-price-box .price').removeClass('price--on-sale')
         $('.price__regular .price-item.price-item--regular').text(var_price)
       }
    }

     if ($(this).text() == comma_seprated && $(this).hasClass('soldout')) {
      aviable = false;
     } 
    
  });

 
if (isFound) {
    setTimeout(function () {
      $(".product-form__buttons button").prop("disabled", false);
      $("button.product-form__submit span").text("Add to cart");
    }, 500);
  }

if(!aviable && isFound){
  setTimeout(function () {
   $(".product-form__buttons button.product-form__submit").prop("disabled", true);
   $(".product-form__buttons button.product-form__submit span").text("Sold out");
  }, 500);   
 } 
  
}

$(document).on("click", ".header__icon--menu", function () {
  console.log("CLICK@");
  $("body").toggleClass("drawer_open");
});
// Product option trigger
// $(document).ready(function () {
//   console.log("product-page");
//   $(".customRadio.color-swatch input:radio:first")
//     .attr("checked", true)
//     .trigger("click");
// });

// $('.header__inline-menu.main-menu .menu-l1__item.has_megamenu-true').hover(function(){
//   $('.menu-l1__item.has_megamenu-true').removeClass('is-active');
//   $(this).addClass('is-active');
// })

$(".header__inline-menu.main-menu .menu-l1__item.has_megamenu-true").hover(function() {
    $('.menu-l1__item.has_megamenu-true').removeClass('is-active');
    $(this).addClass('is-active');
},
function() {
    // $('.menu-l1__item.has_megamenu-true').addClass('is-active');
    $(this).removeClass('is-active');
});



$('a.smooth-redirect').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top - 100
      }, 900, 'swing', function () {
          // window.location.hash = target;
      });
  });


$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});

$(window).scroll(function(){
  if ($(window).width() <= 580) {
    var scroll = $(window).scrollTop();
    var sticky_top = $('.featured--Section-wrapper--main-logo-hs-sds-compare').offset().top;
    var sticky_height = $(window).height();
    sticky_top -= sticky_height;
    if(scroll >= sticky_top){  
      $('section.default-product-sticky').fadeIn();
    }
    else{
      $('section.default-product-sticky').fadeOut();
    }
  }
});

$(".default-product-sticky .sticky-atc").on("click",function(event){
    $('html,body').animate({scrollTop: $(".redirect-pro-price-box").offset().top},900);
  });

var myInterval = setInterval(function () {
    if($('.multiple--collage-wrapper button[data-function]').length){
        $('.multiple--collage-wrapper button').removeAttr('data-function');
        clearInterval(myInterval);
    }  
  }, 100);


// $('.multiple--collage-wrapper button').removeAttr('data-function')
// $('.default-product-sticky .sticky-atc').click(function(){
//   $('button.product-form__submit ').trigger('click');
// })

// $(document).on("click",".collageTemplate--headings",function() {
//   var id = $(this).attr('id');
//   $('.collageTemplate--headings').removeClass('active');
//   $(this).addClass('active');
//   $('.collage--items-wrap .contents__wrap').hide();
//   $('.collage--items-wrap .contents__wrap[data-id="'+id+'"]').show();
// });

// $(document).on("click","li.first-level-link.has-mega--menu a.menu-drawer__menu-item",function() {
//   $(this).parent('.Mmenu-link--heding').toggleClass('active');
// });
// $(document).on("click",".Mmenu--linklist-wrapper .menu--nav li.mega__menu_li.has-submenu",function() {
//   $(this).toggleClass('active');
// });

// if($(window).width() < 767){
//   $(document).on("click",".footer-block__heading",function(e) {
//     e.preventDefault();
//     console.log('dddd')
//     $(this).parent('.footer-block').toggleClass('active');
//   });
// }

$(document).ready(function () {
  $('.match-product-wrap .model-select').on('change',function(){
    var selectedOption = $(this).find('option:selected');
    var redirectUrl = selectedOption.data('url');
    if(redirectUrl){
      window.location.href = redirectUrl;
    }
  });
});